const messages = {
  fr: {
    translations: {

      signup: {
        title: "S'inscrire",
        toasts: {
          success: "Utilisateur créé avec succès ! Connectez-vous !",
          fail: "Erreur lors de la création de l'utilisateur. Vérifiez les données saisies."
        },
        form: {
          name: "Nom",
          email: "E-mail",
          password: "Mot de passe",
          company: "Nom de l'Organisation",
          phone: "WhatsApp (Indicatif régional + NUMÉRO)"
        },
        buttons: {
          submit: "S'inscrire",
          login: "Vous avez déjà un compte ? Connectez-vous !"
        }
      },
      login: {
        title: "Se Connecter",
        form: {
          email: "E-mail",
          password: "Mot de passe",
          button: "Accéder"
        },
        buttons: {
          submit: "Se Connecter",
          register: "Vous n'avez pas de compte ? Inscrivez-vous !"
        }
      },
      companies: {
        title: "Enregistrer l'Entreprise",
        form: {
          name: "Nom de l'Entreprise",
          plan: "Plan",
          token: "Token",
          submit: "Enregistrer",
          success: "Entreprise créée avec succès !"
        }
      },
      registerClient: {
        title: "Enregistrer un client",
        subtitle: "Creez un nouveau compte client et definissez le plan initial.",
        steps: {
          company: "Entreprise",
          contact: "Contact",
          plan: "Plan et modules"
        },
        toasts: {
          stepCompanyRequired: "Renseignez le nom, l'email et le telephone de l'entreprise.",
          stepContactRequired: "Renseignez le nom et l'email du contact.",
          success: "Client enregistre avec succes.",
          error: "Impossible d'enregistrer le client."
        },
        industries: {
          retail: "Commerce",
          restaurant: "Restauration",
          healthcare: "Sante",
          education: "Education",
          technology: "Technologie",
          services: "Services",
          ecommerce: "E-commerce",
          realEstate: "Immobilier",
          other: "Autre"
        },
        company: {
          title: "Informations de l'entreprise",
          fields: {
            name: "Nom de l'entreprise",
            industry: "Secteur",
            email: "Email de l'entreprise",
            phone: "Telephone de l'entreprise",
            address: "Adresse",
            website: "Site web"
          }
        },
        contact: {
          title: "Personne de contact",
          fields: {
            name: "Nom complet",
            position: "Poste",
            email: "Email",
            phone: "Telephone"
          }
        },
        plan: {
          title: "Plan et facturation",
          perMonth: "/mois",
          includes: {
            users: "Utilisateurs",
            connections: "Connexions",
            queues: "Domaines"
          },
          billingCycle: "Cycle de facturation",
          billingMonthly: "Mensuel",
          billingAnnual: "Annuel (2 mois offerts)"
        },
        addons: {
          title: "Modules additionnels",
          pricePerMonth: "$ {{amount}}/mois"
        },
        notes: {
          title: "Notes internes",
          placeholder: "Ajoutez des notes pour l'equipe commerciale..."
        },
        total: {
          label: "Total estime",
          perMonth: " /mois",
          perYear: " /an"
        },
        buttons: {
          back: "Retour",
          next: "Suivant",
          submit: "Enregistrer le client"
        }
      },
      auth: {
        toasts: {
          success: "Connexion réussie !"
        },
        dueDate: {
          expiration: "Votre abonnement expire dans",
          days: "jours !",
          day: "jour !",
          expirationToday: "Votre abonnement expire aujourd'hui !"
        },
        token: "Token"
      },
      dashboard: {
        title: "Tableau de Bord",
        buttons: {
          filter: "Filtrer"
        },
        tabs: {
          indicators: "Indicateurs",
          assessments: "NPS",
          attendants: "Agents",
          performance: "Performance"
        },
        charts: {
          performance: "Graphiques",
          userPerformance: "Graphique des Utilisateurs",
          perDay: {
            title: "Services aujourd'hui : "
          }
        },
        cards: {
          inAttendance: "En Service",
          waiting: "En Attente",
          activeAttendants: "Agents Actifs",
          finalized: "Finalisés",
          newContacts: "Nouveaux Contacts",
          totalReceivedMessages: "Messages Reçus",
          totalSentMessages: "Messages Envoyés",
          averageServiceTime: "T.M. de Service",
          averageWaitingTime: "T.M. d'Attente",
          status: "État (Actuel)",
          activeTickets: "Tickets Actifs",
          passiveTickets: "Tickets Passifs",
          groups: "Groupes"
        },
        users: {
          name: "Nom",
          numberAppointments: "Nombre de Services",
          statusNow: "Actuel",
          totalCallsUser: "Total de services par utilisateur",
          totalAttendances: "Total de services",
          totalLabel: "Total de services : {{count}}",
          queues: "Files d'attente",
          defaultQueue: "Connexion par Défaut",
          workingHours: "Horaires de Travail",
          startWork: "Début de Travail",
          endWork: "Fin de Travail",
          farewellMessage: "Message d'Adieu",
          theme: "Thème par Défaut",
          menu: "Menu par Défaut",
        },
        date: {
          initialDate: "Date Initiale",
          finalDate: "Date Finale"
        },
        licence: {
          available: "Disponible jusqu'au"
        },
        assessments: {
          totalCalls: "Total de Services",
          callsWaitRating: "Services en attente d'évaluation",
          callsWithoutRating: "Services sans évaluation",
          ratedCalls: "Services évalués",
          evaluationIndex: "Indice d'évaluation",
          score: "Score",
          prosecutors: "Promoteurs",
          neutral: "Neutres",
          detractors: "Détracteurs"
        }
      },
      surveyReports: {
        title: "Rapport des Enquêtes Réalisées",
        operator: "Opérateur",
        period: "Période",
        until: "Jusqu'au",
        date: "Date",
        reportTitle: "Rapports",
        calls: "Services",
        search: "Enquêtes",
        durationCalls: "Durée des Services",
        grupoSessions: "Services dans les Groupes",
        groupTicketsReports: {
          timezone: "America/Sao_Paulo",
          msgToast: "Génération du rapport compressé, veuillez patienter.",
          errorToast: "Erreur lors de la génération du rapport",
          back: "Retour",
          groupServiceReport: "Rapport des Services dans les Groupes",
          loading: "Chargement...",
          contact: "Contact",
          dateOpen: "Date d'Ouverture",
          dateLastUpdated: "Date de Dernière Mise à Jour",
          agent: "Qui a Servi",
          agentClosed: "Qui a Fermé",
          waitingAssistance: "En Attente de Service",
          process: "En Service"
        },
        researchReports: {
          response: "réponse",
          active: "(Active)",
          inactive: "(Inactive)",
          quantity: "Quantité",
          percentage: "pourcentage",
          title: "Rapport des Enquêtes Réalisées",
          activeSearch: "Enquête active",
          inactiveSearch: "Enquête inactive"
        },
        ticketDurationDetail: {
          msgToast: "Génération du rapport compressé, veuillez patienter.",
          title: "Rapport de Durée du Service",
          startService: "Début du Service",
          lastUpdated: "Dernière Mise à Jour",
          lastAgent: "Dernier Agent",
          durationFinished: "Durée après finalisation"
        },
        ticketDuration: {
          title: "Rapport de Durée des Services",
          contact: "Contact",
          open: "Ouverts",
          pending: "En Attente",
          finished: "Finalisés",
          durationFinished: "Durée des finalisés",
          durationAfterFinished: "Durée après finalisation",
          actions: "Actions"
        },
        ticketReports: {
          msgToast: "Génération du rapport compressé, veuillez patienter.",
          title: "Rapport des Services"
        },
        pdf: {
          title: "Relation des Services Réalisés",
          exportTitle: "Relation des Services dans les Groupes Réalisés"
        }
      },
      todo: {
        newTask: "Nouvelle Tâche",
        add: "Ajouter",
        task: "Tâches"
      },
      contactImportWpModal: {
        title: "Exporter les Contacts vers Excel",
        buttons: {
          downloadModel: "Télécharger le modèle Excel pour l'importation",
          closed: "Fermer",
          import: "Sélectionnez le fichier Excel pour importer les Contacts"
        }
      },
      companyWhatsapps: {
        title: "Connexions de : {{name}}",
      },
      connections: {
        title: "Connexions",
        waitConnection: "Attendez... Vos connexions vont redémarrer !",
        newConnection: "Nouvelle Connexion",
        restartConnections: "Redémarrer les Connexions",
        callSupport: "Appeler le Support",
        toasts: {
          deleted: "Connexion supprimée avec succès !",
          closedimported: "Nous fermons les tickets importés, veuillez patienter quelques instants"
        },
        confirmationModal: {
          closedImportedTitle: "Fermer les tickets importés",
          closedImportedMessage: "Si vous confirmez, tous les tickets importés seront fermés",
          deleteTitle: "Supprimer",
          deleteMessage: "Êtes-vous sûr ? Cette action ne peut pas être annulée.",
          disconnectTitle: "Déconnecter",
          disconnectMessage: "Êtes-vous sûr ? Vous devrez lire le code QR à nouveau."
        },
        buttons: {
          add: "Ajouter une Connexion",
          disconnect: "Déconnecter",
          tryAgain: "Réessayer",
          qrcode: "CODE QR",
          newQr: "Nouveau CODE QR",
          closedImported: "Fermer tous les tickets importés",
          preparing: "Préparation des messages pour l'importation",
          importing: "Importation des Messages WhatsApp",
          processed: "Traité",
          in: "de",
          connecting: "Connexion"
        },
        typography: {
          processed: "Traité",
          in: "de",
          date: "Date du message"
        },
        toolTips: {
          disconnected: {
            title: "Erreur lors de la connexion à WhatsApp",
            content: "Assurez-vous que votre téléphone est connecté à Internet et réessayez, ou demandez un nouveau Code QR"
          },
          qrcode: {
            title: "En attente de la lecture du Code QR",
            content: "Cliquez sur le bouton 'CODE QR' et lisez le Code QR avec votre téléphone pour vous connecter"
          },
          connected: {
            title: "Connexion établie !"
          },
          timeout: {
            title: "La connexion avec le téléphone a été perdue",
            content: "Assurez-vous que votre téléphone est connecté à Internet et que WhatsApp est ouvert, ou cliquez sur le bouton 'Déconnecter' pour obtenir un nouveau Code QR"
          }
        },
        table: {
          name: "Nom",
          status: "État",
          lastUpdate: "Dernière mise à jour",
          "default": "Par Défaut",
          actions: "Actions",
          session: "Session",
          number: "Numéro de WhatsApp"
        }
      },
      showTicketOpenModal: {
        title: {
          header: "Service Existant"
        },
        form: {
          message: "Ce contact est déjà en service :",
          user: "Agent",
          queue: "File d'attente",
          messageWait: "Ce contact attend déjà un service. Allez dans l'onglet En Attente !"
        }
      },
      showTicketLogModal: {
        title: {
          header: "Enregistrements"
        },
        options: {
          create: "Ticket créé.",
          chatBot: "ChatBot démarré.",
          queue: " - File d'attente définie.",
          open: " a commencé le service.",
          access: "a accédé au ticket.",
          transfered: "a transféré le ticket.",
          receivedTransfer: "a reçu le ticket transféré.",
          pending: "a renvoyé à la file d'attente.",
          closed: "a fermé le ticket",
          reopen: "a rouvert le ticket",
          redirect: "- redirigé"
        }
      },
      whatsappModal: {
        title: {
          add: "Ajouter une Connexion",
          edit: "Modifier la Connexion"
        },
        tabs: {
          general: "Général",
          messages: "Messages",
          assessments: "NPS",
          integrations: "Intégrations",
          schedules: "Horaires de service"
        },
        form: {
          importOldMessagesEnable: "Importer les messages de l'appareil",
          importOldMessages: "Date de début de l'importation",
          importRecentMessages: "Date de fin de l'importation",
          importOldMessagesGroups: "Importer les messages de groupe",
          closedTicketsPostImported: "Fermer les tickets après l'importation",
          name: "Nom",
          queueRedirection: "Redirection de File d'attente",
          queueRedirectionDesc: "Sélectionnez une file d'attente pour que les contacts sans file d'attente soient redirigés",
          "default": "Par Défaut",
          group: "Autoriser les groupes",
          timeSendQueue: "Temps en minutes pour rediriger vers la file d'attente",
          importAlert: "ATTENTION : En enregistrant, votre connexion sera fermée, il sera nécessaire de lire à nouveau le Code QR pour importer les messages",
          groupAsTicket: "Traiter les groupes comme ticket",
          timeCreateNewTicket: "Créer un nouveau ticket dans x minutes",
          maxUseBotQueues: "Envoyer le bot x fois",
          timeUseBotQueues: "Envoyer le bot dans x minutes",
          expiresTicket: "Fermer les chats ouverts après x minutes",
          expiresTicketNPS: "Fermer les chats en attente d'évaluation après x minutes",
          maxUseBotQueuesNPS: "Nombre maximum de fois que l'évaluation sera envoyée",
          closeLastMessageOptions1: "De l'agent/Client",
          closeLastMessageOptions2: "De l'agent",
          outOfHoursMessage: "Message hors horaires de service",
          greetingMessage: "Message de bienvenue",
          complationMessage: "Message de conclusion",
          lgpdLinkPrivacy: "Lien vers la politique de confidentialité",
          lgpdMessage: "Message de bienvenue RGPD",
          lgpdDeletedMessages: "Masquer le message supprimé par le contact",
          lgpdSendMessage: "Toujours demander la confirmation du contact",
          ratingMessage: "Message d'évaluation - L'échelle doit être de 0 à 10",
          token: "Token pour intégration externe",
          sendIdQueue: "File d'attente",
          inactiveMessage: "Message d'inactivité",
          timeInactiveMessage: "Temps en minutes pour l'envoi de l'avis d'inactivité",
          whenExpiresTicket: "Fermer les chats ouverts quand le dernier message est",
          expiresInactiveMessage: "Message de fermeture par inactivité",
          prompt: "Prompt",
          collectiveVacationEnd: "Date de fin",
          collectiveVacationStart: "Date de début",
          collectiveVacationMessage: "Message de vacances collectives",
          queueIdImportMessages: "File d'attente pour importer les messages"
        },
        buttons: {
          okAdd: "Ajouter",
          okEdit: "Enregistrer",
          cancel: "Annuler"
        },
        menuItem: {
          enabled: "Activé",
          disabled: "Désactivé",
          minutes: "minutes"
        },
        success: "Connexion enregistrée avec succès.",
        errorSendQueue: "Un temps pour rediriger la file d'attente a été informé, mais aucune file n'a été sélectionnée pour rediriger. Les deux champs doivent être remplis",
        errorExpiresNPS: "Il est obligatoire d'informer un temps pour l'évaluation lors de l'utilisation du NPS.",
        errorRatingMessage: "Il est obligatoire d'informer un message d'évaluation lors de l'utilisation du NPS."
      },
      qrCode: {
        message: "Lisez le QrCode pour démarrer la session"
      },
      contacts: {
        title: "Contacts",
        toasts: {
          deleted: "Contact supprimé avec succès !"
        },
        searchPlaceholder: "Rechercher...",
        confirmationModal: {
          deleteTitle: "Supprimer ",
          importTitlte: "Importer des contacts",
          exportContact: "Exporter des contacts",
          deleteMessage: "Êtes-vous sûr de vouloir supprimer ce contact ? Tous les services associés seront perdus.",
          blockContact: "Êtes-vous sûr de vouloir bloquer ce contact ?",
          unblockContact: "Êtes-vous sûr de vouloir débloquer ce contact ?",
          importMessage: "Voulez-vous importer tous les contacts du téléphone ?",
          importChat: "Importer les Conversations",
          wantImport: "Voulez-vous importer toutes les conversations du téléphone ?"
        },
        buttons: {
          import: "Importer des Contacts",
          add: "Ajouter un Contact",
          export: "Exporter un Contact"
        },
        table: {
          name: "Nom",
          whatsapp: "Connexion",
          email: "E-mail",
          actions: "Actions",
          lastMessage: "Dernier Message"
        },
        menu: {
          importYourPhone: "Importer de l'appareil par défaut",
          importToExcel: "Importer / Exporter depuis Excel"
        }
      },
      forwardMessage: {
        text: "Transféré"
      },
      forwardMessageModal: {
        title: "Transférer le message",
        buttons: {
          ok: "Transférer"
        },
        status: {
          sending: "Envoi du message {{id}}..."
        },
        errors: {
          noContactFound: "Aucun contact trouvé avec le nom {{name}}"
        }
      },
      promptModal: {
        form: {
          name: "Nom",
          prompt: "Prompt",
          voice: "Voix",
          max_tokens: "Maximum de Tokens dans la réponse",
          temperature: "Température",
          apikey: "Clé API",
          max_messages: "Maximum de messages dans l'Historique",
          voiceKey: "Clé de l'API de Voix",
          voiceRegion: "Région de Voix"
        },
        success: "Prompt enregistré avec succès !",
        title: {
          add: "Ajouter un Prompt",
          edit: "Modifier le Prompt"
        },
        buttons: {
          okAdd: "Ajouter",
          okEdit: "Enregistrer",
          cancel: "Annuler"
        }
      },
      prompts: {
        title: "Prompts",
        tabs: {
          prompts: "Prompts",
          knowledgeBase: "Base de Connaissance",
          aiSettings: "Paramètres IA"
        },
        table: {
          name: "Nom",
          queue: "Secteur/File d'attente",
          max_tokens: "Maximum Tokens Réponse",
          actions: "Actions"
        },
        confirmationModal: {
          deleteTitle: "Supprimer",
          deleteMessage: "Êtes-vous sûr ? Cette action ne peut pas être annulée !"
        },
        buttons: {
          add: "Ajouter un Prompt"
        },
        knowledgeBase: {
          buttons: {
            upload: "Téléverser un fichier",
            addText: "Ajouter du texte"
          },
          table: {
            title: "Titre",
            type: "Type",
            status: "Statut",
            size: "Taille",
            createdAt: "Créé",
            actions: "Actions"
          },
          status: {
            indexed: "Indexé",
            stored: "Stocké",
            processing: "Traitement",
            failed: "Échec",
            pending: "En attente"
          },
          empty: "Aucun document pour le moment.",
          modalUpload: {
            title: "Téléverser un document",
            form: {
              title: "Titre (optionnel)",
              description: "Description (optionnelle)"
            },
            buttons: {
              cancel: "Annuler",
              send: "Téléverser"
            }
          },
          modalText: {
            title: "Ajouter du texte",
            form: {
              title: "Titre",
              description: "Description (optionnelle)",
              content: "Contenu"
            },
            buttons: {
              cancel: "Annuler",
              save: "Enregistrer"
            }
          },
          confirm: {
            deleteTitle: "Supprimer",
            deleteMessage: "Êtes-vous sûr ? Cette action ne peut pas être annulée !"
          },
          toasts: {
            uploaded: "Document téléversé.",
            created: "Document créé.",
            deleted: "Document supprimé.",
            fileRequired: "Le fichier est obligatoire.",
            titleRequired: "Le titre est obligatoire.",
            contentRequired: "Le contenu est obligatoire."
          }
        },
        aiSettings: {
          form: {
            isEnabled: "IA activée",
            openaiModel: "Modèle",
            openaiTemperature: "Température",
            openaiMaxTokens: "Tokens max",
            useRag: "Utiliser la base de connaissance (RAG)",
            ragTopK: "RAG Top K",
            ragMinScore: "Score min RAG",
            maxHistory: "Historique max",
            personality: "Personnalité",
            instructions: "Instructions",
            language: "Langue (code ISO)"
          },
          usage: {
            limit: "Limite de tokens",
            used: "Utilisés",
            remaining: "Restants",
            addTokens: "Ajouter des tokens"
          },
          buttons: {
            save: "Enregistrer",
            addTokens: "Ajouter"
          },
          toasts: {
            saved: "Paramètres IA enregistrés.",
            tokensInvalid: "Les tokens doivent être supérieurs à 0.",
            tokensAdded: "Tokens ajoutés."
          }
        }
      },
      contactModal: {
        title: {
          add: "Ajouter un contact",
          edit: "Modifier le contact"
        },
        form: {
          mainInfo: "Données du contact",
          extraInfo: "Informations supplémentaires",
          name: "Nom",
          number: "Numéro de WhatsApp",
          email: "E-mail",
          extraName: "Nom du champ",
          extraValue: "Valeur",
          chatBotContact: "Désactiver le chatbot",
          termsLGDP: "Termes RGPD acceptés le :",
          whatsapp: "Connexion Source : "
        },
        buttons: {
          addExtraInfo: "Ajouter une information",
          okAdd: "Ajouter",
          okEdit: "Enregistrer",
          cancel: "Annuler"
        },
        success: "Contact enregistré avec succès."
      },
      flowbuilder: {
        title: "Flowbuilder",
        subMenus: {
          campaign: "Flux de Campagne",
          conversation: "Flux de Conversation"
        }
      },
      flowbuilderModal: {
        flowNotIdPhrase: "Flux par défaut"
      },
      queueModal: {
        title: {
          queueData: "Données de la file d'attente",
          text: "Horaires de service",
          add: "Ajouter une file d'attente",
          edit: "Modifier la file d'attente",
          confirmationDelete: "Êtes-vous sûr ? Toutes les options d'intégrations seront supprimées."
        },
        form: {
          name: "Nom",
          color: "Couleur",
          orderQueue: "Ordre de la file d'attente (Bot)",
          rotate: "Rotation",
          timeRotate: "Temps de Rotation",
          minutes: "minutes",
          none: "Aucune",
          greetingMessage: "Message de bienvenue",
          complationMessage: "Message de conclusion",
          outOfHoursMessage: "Message hors horaires de service",
          token: "Token",
          integrationId: "Intégration",
          fileListId: "Liste de fichiers",
          closeTicket: "Fermer le ticket",
          queueType: "Type de menu",
          message: "Message de retour",
          queue: "File d'attente pour transfert",
          integration: "Intégration",
          file: "Fichier",
          selectFile: "Sélectionnez un fichier"
        },
        buttons: {
          okAdd: "Ajouter",
          okEdit: "Enregistrer",
          cancel: "Annuler"
        },
        bot: {
          title: "Options",
          toolTipTitle: "Ajoutez des options pour construire un chatbot",
          toolTip: "S'il n'y a qu'une seule option, elle sera choisie automatiquement, faisant que le bot réponde avec le message de l'option et continue",
          selectOption: "Sélectionnez une option",
          text: "Texte",
          attendent: "Agent",
          queue: "File d'attente",
          integration: "Intégration",
          file: "Fichier",
          toolTipMessageTitle: "Le message est obligatoire pour continuer au niveau suivant",
          toolTipMessageContent: "Le message est obligatoire pour continuer au niveau suivant",
          selectUser: "Sélectionnez un Utilisateur",
          selectQueue: "Sélectionnez une File d'attente",
          selectIntegration: "Sélectionnez une Intégration",
          addOptions: "Ajouter des options"
        },
        serviceHours: {
          dayWeek: "Jour de la semaine",
          startTimeA: "Heure de Début - Équipe A",
          endTimeA: "Heure de Fin - Équipe A",
          startTimeB: "Heure de Début - Équipe B",
          endTimeB: "Heure de Fin - Équipe B",
          monday: "Lundi",
          tuesday: "Mardi",
          wednesday: "Mercredi",
          thursday: "Jeudi",
          friday: "Vendredi",
          saturday: "Samedi",
          sunday: "Dimanche"
        }
      },
      queueIntegrationModal: {
        title: {
          add: "Ajouter un projet",
          edit: "Modifier le projet"
        },
        form: {
          id: "ID",
          type: "Type",
          name: "Nom",
          projectName: "Nom du Projet",
          language: "Langue",
          jsonContent: "Contenu Json",
          urlN8N: "URL",
          typebotSlug: "Typebot - Slug",
          typebotExpires: "Temps en minutes pour expirer une conversation",
          typebotKeywordFinish: "Mot pour finaliser le ticket",
          typebotKeywordRestart: "Mot pour redémarrer le flux",
          typebotRestartMessage: "Message lors du redémarrage de la conversation",
          typebotUnknownMessage: "Message d'option invalide",
          typebotDelayMessage: "Intervalle (ms) entre les messages"
        },
        buttons: {
          okAdd: "Ajouter",
          okEdit: "Enregistrer",
          cancel: "Annuler",
          test: "Tester le Bot"
        },
        messages: {
          testSuccess: "Intégration testée avec succès !",
          addSuccess: "Intégration ajoutée avec succès.",
          editSuccess: "Intégration modifiée avec succès."
        }
      },
      userModal: {
        warning: "Pour effectuer l'importation des messages, il est nécessaire de lire à nouveau le qrCode !!!",
        title: {
          add: "Ajouter un utilisateur",
          edit: "Modifier l'utilisateur",
          updateImage: "Mettre à jour l'image",
          removeImage: "Supprimer l'image"
        },
        form: {
          name: "Nom",
          none: "Aucun",
          email: "E-mail",
          password: "Mot de passe",
          passwordHint: "Laisser vide pour conserver le mot de passe actuel",
          confirmPassword: "Confirmer le mot de passe",
          farewellMessage: "Message d'adieu",
          profile: "Profil",
          startWork: "Début de travail",
          endWork: "Fin de travail",
          whatsapp: "Connexion par Défaut",
          allTicketEnable: "Activé",
          allTicketDisable: "Désactivé",
          allTicket: "Visualiser les appels sans file d'attente",
          allowGroup: "Autoriser les Groupes",
          defaultMenuOpen: "Ouvert",
          defaultMenuClosed: "Fermé",
          defaultMenu: "Menu par défaut",
          defaultTheme: "Thème par Défaut",
          defaultThemeDark: "Sombre",
          defaultThemeLight: "Clair",
          allHistoric: "Voir les conversations des autres files d'attente",
          allHistoricEnabled: "Activé",
          allHistoricDisabled: "Désactivé",
          allUserChat: "Voir les conversations des autres utilisateurs",
          userClosePendingTicket: "Permettre de fermer les tickets en attente",
          showDashboard: "Voir le Dashboard",
          allowRealTime: "Voir le Panneau de Services",
          allowConnections: "Autoriser les actions dans les connexions"
        },
        tabs: {
          general: "Général",
          permissions: "Permissions"
        },
        permissions: {
          noPermission: "Vous n'avez pas la permission d'éditer cette section."
        },
        buttons: {
          okAdd: "Ajouter",
          okEdit: "Enregistrer",
          cancel: "Annuler",
          addImage: "Ajouter une Image",
          editImage: "Modifier l'Image",
          resetPassword: "Réinitialiser le mot de passe",
          togglePassword: "Afficher/masquer le mot de passe"
        },
        errors: {
          passwordRequired: "Le mot de passe est obligatoire."
        },
        toasts: {
          passwordGenerated: "Mot de passe généré.",
          passwordGeneratedCopied: "Mot de passe généré et copié dans le presse-papiers."
        },
        success: "Utilisateur enregistré avec succès."
      },
      companyModal: {
        title: {
          add: "Ajouter une entreprise",
          edit: "Modifier l'entreprise"
        },
        form: {
          name: "Nom",
          email: "E-mail",
          passwordDefault: "Mot de passe",
          numberAttendants: "Utilisateurs",
          numberConections: "Connexions"
        },
        buttons: {
          okAdd: "Ajouter",
          okEdit: "Enregistrer",
          cancel: "Annuler"
        },
        success: "Entreprise enregistrée avec succès."
      },
      scheduleModal: {
        title: {
          add: "Nouvel envoi massif",
          edit: "Modifier l'envoi massif"
        },
        statusTitle: {
          sendError: "Erreur d'envoi",
          messageWithStatus: "Message {{status}}"
        },
        form: {
          body: "Message",
          contact: "Contact",
          sendAt: "Date d'envoi",
          sentAt: "Date d'Envoi",
          assinar: "Envoyer la Signature"
        },
        labels: {
          attachedFile: "Fichier joint : {{name}}"
        },
        buttons: {
          okAdd: "Ajouter",
          okEdit: "Enregistrer",
          cancel: "Annuler",
          attachFile: "Joindre un fichier",
          addSchedule: "Ajouter un envoi massif"
        },
        success: "Envoi massif enregistré avec succès."
      },
      recurrence: {
        title: "Récurrence",
        description:
          "Vous pouvez envoyer le message de manière récurrente et choisir l'intervalle. S'il s'agit d'un envoi unique, ne modifiez rien dans cette section.",
        interval: {
          label: "Intervalle",
          valueLabel: "Valeur de l'intervalle",
          options: {
            days: "Jours",
            weeks: "Semaines",
            months: "Mois",
            minutes: "Minutes"
          }
        },
        sendCount: {
          label: "Nombre d'envois"
        },
        businessDaysPolicy: {
          label: "Jours non ouvrés",
          options: {
            normal: "Envoyer normalement les jours non ouvrés",
            before: "Envoyer un jour ouvré avant",
            after: "Envoyer un jour ouvré après"
          }
        },
        showUser: "Afficher l'utilisateur"
      },
      tagModal: {
        title: {
          add: "Nouvelle Étiquette",
          edit: "Modifier l'Étiquette",
          addKanban: "Nouvelle Colonne",
          editKanban: "Modifier la Colonne"
        },
        form: {
          name: "Nom",
          color: "Couleur",
          timeLane: "Temps en heures pour rediriger vers la colonne",
          nextLaneId: "Colonne",
          greetingMessageLane: "Message de bienvenue de la colonne",
          rollbackLaneId: "Retourner à la Colonne après la reprise du service"
        },
        buttons: {
          okAdd: "Ajouter",
          okEdit: "Enregistrer",
          cancel: "Annuler"
        },
        success: "Étiquette enregistrée avec succès.",
        successKanban: "Colonne enregistrée avec succès."
      },
      fileModal: {
        title: {
          add: "Ajouter une liste de fichiers",
          edit: "Modifier la liste de fichiers"
        },
        buttons: {
          okAdd: "Enregistrer",
          okEdit: "Modifier",
          cancel: "Annuler",
          fileOptions: "Ajouter un fichier"
        },
        form: {
          name: "Nom de la liste de fichiers",
          message: "Détails de la liste",
          fileOptions: "Liste de fichiers",
          extraName: "Message à envoyer avec le fichier",
          extraValue: "Valeur de l'option"
        },
        success: "Liste de fichiers enregistrée avec succès !"
      },
      chat: {
        noTicketMessage: "Sélectionnez un ticket pour commencer à converser.",
        configureApis: "Configurer les API"
      },
      uploads: {
        titles: {
          titleUploadMsgDragDrop: "⬇️ GLISSEZ ET DÉPOSEZ LES FICHIERS DANS LE CHAMP CI-DESSOUS ⬇️",
          titleFileList: "Liste de fichier(s)"
        }
      },
      chatInternal: {
        new: "Nouveau",
        tabs: {
          chats: "Discussions",
          messages: "Messages"
        },
        aria: {
          tabs: "Onglets du chat interne"
        },
        modal: {
          conversation: "Conversation",
          title: "Titre",
          filterUsers: "Filtrer par Utilisateurs",
          cancel: "Fermer",
          save: "Enregistrer"
        },
        modalDelete: {
          title: "Supprimer la Conversation",
          message: "Cette action ne peut pas être annulée, confirmer ?"
        }
      },
      ticketsAdvanced: {
        tabs: {
          ticket: "Ticket",
          services: "Services"
        }
      },
      momentsUser: {
        pending: "En attente",
        labels: {
          servicesCount: "Services : {{count}}"
        }
      },
      ticketsManager: {
        questionCloseTicket: "VOULEZ-VOUS FERMER TOUS LES TICKETS ?",
        yes: "OUI",
        not: "NON",
        buttons: {
          newTicket: "Nouveau",
          resolveAll: "Résoudre Tous",
          close: "Fermer",
          new: "Nouveau"
        }
      },
      ticketsQueueSelect: {
        placeholder: "Files d'attente"
      },
      tickets: {
        inbox: {
          closedAllTickets: "Fermer tous les tickets ?",
          closedAll: "Fermer Tous",
          newTicket: "Nouveau Ticket",
          yes: "OUI",
          no: "NON",
          open: "Ouverts",
          sortAscending: "Ascendant",
          sortDescending: "Descendant",
          resolverd: "Résolus"
        },
        toasts: {
          deleted: "Le service dans lequel vous étiez a été supprimé."
        },
        notification: {
          message: "Message de"
        },
        tabs: {
          open: {
            title: "Ouverts"
          },
          closed: {
            title: "Résolus"
          },
          search: {
            title: "Recherche"
          }
        },
        search: {
          placeholder: "Rechercher un service et des messages",
          filterConections: "Filtrer par Connexion",
          filterConectionsOptions: {
            open: "Ouvert",
            closed: "Fermé",
            pending: "En Attente"
          },
          filterUsers: "Filtrer par Utilisateurs",
          filterContacts: "Filtrer par Contacts",
          ticketsPerPage: "Tickets par page"
        },
        buttons: {
          showAll: "Tous",
          returnQueue: "Retourner à la File d'attente",
          scredule: "Programmation",
          deleteTicket: "Supprimer le Ticket"
        },
        closedTicket: {
          closedMessage: "Fermer le Ticket Avec Message d'Adieu",
          closedNotMessage: "Fermer le Ticket Sans Message d'Adieu"
        },
        simulateIncoming: {
          channelFallback: "canal",
          body: "Message de test ({{channel}})",
          menuLabel: "Simuler un message entrant",
          toasts: {
            success: "Message entrant simulé."
          }
        }
      },
      transferTicketModal: {
        title: "Transférer le Ticket",
        fieldLabel: "Tapez pour rechercher des utilisateurs",
        fieldQueueLabel: "Transférer vers la file d'attente",
        fieldQueuePlaceholder: "Sélectionnez une file d'attente",
        fieldWhatsapp: "Sélectionnez un WhatsApp",
        noOptions: "Aucun utilisateur trouvé avec ce nom",
        msgTransfer: "Observations - message interne, ne va pas au client",
        buttons: {
          ok: "Transférer",
          cancel: "Annuler"
        }
      },
      ticketsList: {
        called: "Appelé",
        today: "Aujourd'hui",
        missedCall: "Appel vocal/vidéo manqué à",
        pendingHeader: "En Attente",
        assignedHeader: "En Service",
        groupingHeader: "Groupes",
        noTicketsTitle: "Rien ici !",
        noTicketsMessage: "Aucun service trouvé avec cet état ou terme recherché",
        noQueue: "Sans File d'attente",
        buttons: {
          accept: "Accepter",
          cancel: "Annuler",
          start: "Démarrer",
          closed: "Fermer",
          reopen: "Rouvrir",
          transfer: "Transférer",
          ignore: "Ignorer",
          exportAsPDF: "Exporter en PDF",
          kanbanActions: "Options de Kanban"
        },
        acceptModal: {
          title: "Accepter le Chat",
          queue: "Sélectionner le secteur"
        }
      },
      newTicketModal: {
        title: "Créer un Ticket",
        fieldLabel: "Tapez pour rechercher le contact",
        add: "Ajouter",
        buttons: {
          ok: "Enregistrer",
          cancel: "Annuler"
        }
      },
      SendContactModal: {
        title: "Envoyer un contact",
        fieldLabel: "Tapez pour rechercher le contact",
        add: "Ajouter",
        buttons: {
          ok: "Envoyer",
          cancel: "Annuler"
        }
      },
      mainDrawer: {
        listItems: {
          dashboard: "Tableau de Bord",
          connections: "Connexions",
          chatsTempoReal: "Panneau",
          tickets: "Services",
          quickMessages: "Réponses rapides",
          contacts: "Contacts",
          queues: "Zones & Chatbot",
          flowbuilder: "Flowbuilder",
          tags: "Étiquettes",
          administration: "Administration",
          companies: "Entreprises",
          users: "Utilisateurs",
          settings: "Paramètres",
          files: "Liste de fichiers",
          helps: "Aide",
          messagesAPI: "Connecter APIs",
          schedules: "Envois en masse",
          campaigns: "Campagnes",
          annoucements: "Informatifs",
          chats: "Chat Interne",
          financeiro: "Financier",
          queueIntegration: "Intégrations",
          version: "Version",
          kanban: "Kanban",
          prompts: "Talk.Ai",
          allConnections: "Gérer les connexions",
          reports: "Rapports",
          management: "Gestion",
          subscription: "Abonnement",
          salesDashboard: "Dashboard des ventes",
          leads: "Prospects",
          registerClient: "Enregistrer client",
          commission: "Commissions",
          teamDashboard: "Dashboard équipe",
          analytics: "Analyses",
          clientDashboard: "Mon dashboard",
          inbox: "Boîte de réception",
          whatsappApi: "WhatsApp API",
          whatsappQr: "WhatsApp QR",
          facebookInstagram: "Facebook / Instagram",
          ai: "IA"
        },
        sections: {
          main: "Principal",
          sales: "Ventes",
          service: "Support",
          marketing: "Marketing",
          aiAutomation: "IA & Automatisation",
          tools: "Outils",
          team: "Équipe",
          reports: "Rapports",
          channels: "Canaux"
        },
        appBar: {
          user: {
            profile: "Profil",
            logout: "Déconnexion",
            message: "Bonjour",
            messageEnd: "bienvenue à",
            active: "Actif jusqu'au",
            goodMorning: "Bonjour,",
            myName: "je m'appelle",
            continuity: "et je donnerai suite à votre service.",
            virtualAssistant: "datxale",
            token: "Token invalide, veuillez contacter l'administrateur de la plateforme."
          },
          message: {
            location: "Localisation",
            contact: "Contact"
          },
          notRegister: "Aucun enregistrement",
          refresh: "Actualiser"
        }
      },
      languages: {
        undefined: "Langue",
        es: "Espagnol",
        en: "English",
        "pt-BR": "Portugais",
        fr: "Français",
        it: "Italien"
      },
      messagesAPI: {
        title: "Connecter APIs",
        textMessage: {
          number: "Numéro",
          body: "Message",
          token: "Token enregistré",
          userId: "ID de l'utilisateur/agent",
          queueId: "ID de la File d'attente"
        },
        mediaMessage: {
          number: "Numéro",
          body: "Nom du fichier",
          media: "Fichier",
          token: "Token enregistré"
        },
        API: {
          title: "Documentation pour l'envoi de messages",
          methods: {
            title: "Méthodes d'Envoi",
            messagesText: "Messages Texte",
            messagesMidia: "Messages Média"
          },
          instructions: {
            title: "Instructions",
            comments: "Observations Importantes",
            comments1: "Avant d'envoyer des messages, il est nécessaire d'enregistrer le token lié à la connexion qui enverra les messages. <br />Pour effectuer l'enregistrement, accédez au menu 'Connexions', cliquez sur le bouton modifier de la connexion et insérez le token dans le champ approprié.",
            comments2: "Le numéro pour l'envoi ne doit pas avoir de masque ou de caractères spéciaux et doit être composé de :",
            codeCountry: "Code du Pays",
            code: "Indicatif régional",
            number: "Numéro"
          },
          text: {
            title: "1. Messages Texte",
            instructions: "Voici la liste des informations nécessaires pour l'envoi de messages texte :"
          },
          media: {
            title: "2. Messages Média",
            instructions: "Voici la liste des informations nécessaires pour l'envoi de messages média :"
          }
        }
      },
      notifications: {
        noTickets: "Aucune notification."
      },
      quickMessages: {
        title: "Réponses Rapides",
        searchPlaceholder: "Rechercher...",
        noAttachment: "Sans pièce jointe",
        confirmationModal: {
          deleteTitle: "Suppression",
          deleteMessage: "Cette action est irréversible ! Voulez-vous continuer ?"
        },
        buttons: {
          add: "Ajouter",
          attach: "Joindre un Fichier",
          cancel: "Annuler",
          edit: "Modifier"
        },
        toasts: {
          success: "Raccourci ajouté avec succès !",
          deleted: "Raccourci supprimé avec succès !"
        },
        dialog: {
          title: "Message Rapide",
          shortcode: "Raccourci",
          message: "Réponse",
          save: "Enregistrer",
          cancel: "Annuler",
          geral: "Permettre la modification",
          add: "Ajouter",
          edit: "Modifier",
          visao: "Permettre la visualisation"
        },
        table: {
          shortcode: "Raccourci",
          message: "Message",
          actions: "Actions",
          mediaName: "Nom du Fichier",
          status: "État"
        }
      },
      contactLists: {
        title: "Listes de Contacts",
        table: {
          name: "Nom",
          contacts: "Contacts",
          actions: "Actions"
        },
        buttons: {
          add: "Nouvelle Liste"
        },
        dialog: {
          name: "Nom",
          company: "Entreprise",
          okEdit: "Modifier",
          okAdd: "Ajouter",
          add: "Ajouter",
          edit: "Modifier",
          cancel: "Annuler"
        },
        confirmationModal: {
          deleteTitle: "Supprimer",
          deleteMessage: "Cette action ne peut pas être annulée."
        },
        toasts: {
          deleted: "Enregistrement supprimé"
        }
      },
      contactListItems: {
        title: "Contacts",
        searchPlaceholder: "Recherche",
        buttons: {
          add: "Nouveau",
          lists: "Listes",
          import: "Importer"
        },
        dialog: {
          name: "Nom",
          number: "Numéro",
          whatsapp: "WhatsApp",
          email: "E-mail",
          okEdit: "Modifier",
          okAdd: "Ajouter",
          add: "Ajouter",
          edit: "Modifier",
          cancel: "Annuler"
        },
        table: {
          name: "Nom",
          number: "Numéro",
          whatsapp: "WhatsApp",
          email: "E-mail",
          actions: "Actions"
        },
        confirmationModal: {
          deleteTitle: "Supprimer",
          deleteMessage: "Cette action ne peut pas être annulée.",
          importMessage: "Voulez-vous importer les contacts de cette feuille ? ",
          importTitlte: "Importer"
        },
        toasts: {
          deleted: "Enregistrement supprimé"
        }
      },
      kanban: {
        title: "Kanban",
        searchPlaceholder: "Recherche",
        subMenus: {
          list: "Panneau",
          tags: "Couloirs"
        }
      },
      campaigns: {
        title: "Campagnes",
        searchPlaceholder: "Recherche",
        subMenus: {
          list: "Liste",
          listContacts: "Liste de contacts",
          settings: "Paramètres"
        },
        settings: {
          randomInterval: "Intervalle Aléatoire de Déclenchement",
          noBreak: "Sans Intervalle",
          intervalGapAfter: "Intervalle plus grand après",
          undefined: "Non défini",
          messages: "messages",
          laggerTriggerRange: "Intervalle de déclenchement plus grand",
          addVar: "Ajouter une variable",
          save: "Enregistrer",
          close: "Fermer",
          add: "Ajouter",
          shortcut: "Raccourci",
          content: "Contenu"
        },
        buttons: {
          add: "Nouvelle Campagne",
          contactLists: "Listes de Contacts"
        },
        table: {
          name: "Nom",
          whatsapp: "Connexion",
          contactList: "Liste de Contacts",
          option: "Aucune",
          disabled: "Désactivée",
          enabled: "Activée",
          status: "État",
          scheduledAt: "Programmation",
          completedAt: "Terminée",
          confirmation: "Confirmation",
          actions: "Actions"
        },
        actions: {
          start: "Démarrer",
          stop: "Arrêter",
          restart: "Redémarrer"
        },
        dialog: {
          new: "Nouvelle Campagne",
          update: "Modifier la Campagne",
          readonly: "Visualisation Uniquement",
          help: "Utilisez des variables comme {nome}, {numero}, {email} ou définissez des variables personnalisées.",
          validation: {
            required: "Champ requis",
            nameMin: "Minimum 2 caractères",
            nameMax: "Maximum 50 caractères"
          },
          form: {
            name: "Nom",
            message1: "Message 1",
            message2: "Message 2",
            message3: "Message 3",
            message4: "Message 4",
            message5: "Message 5",
            confirmationMessage1: "Message de Confirmation 1",
            confirmationMessage2: "Message de Confirmation 2",
            confirmationMessage3: "Message de Confirmation 3",
            confirmationMessage4: "Message de Confirmation 4",
            confirmationMessage5: "Message de Confirmation 5",
            messagePlaceholder: "Contenu du message",
            whatsapp: "Connexion",
            status: "État",
            scheduledAt: "Programmation",
            confirmation: "Confirmation",
            contactList: "Liste de Contact",
            tagList: "Étiquettes",
            statusTicket: "État du Ticket",
            openTicketStatus: "Ouvert",
            pendingTicketStatus: "En Attente",
            closedTicketStatus: "Fermé",
            enabledOpenTicket: "Activé",
            disabledOpenTicket: "Désactivé",
            openTicket: "Ouvrir le ticket",
            sendType: "Type d'envoi",
            sendTypeTemplate: "Modèle (Meta)",
            sendTypeText: "Texte",
            template: "Modèle",
            templatePlaceholder: "Sélectionner un modèle",
            templateLoading: "Chargement des modèles...",
            templateEmpty: "Aucun modèle approuvé",
            templateSelectWhatsapp: "Sélectionnez une connexion d'abord"
          },
          buttons: {
            add: "Ajouter",
            edit: "Mettre à jour",
            okadd: "Ok",
            cancel: "Annuler les Déclenchements",
            restart: "Redémarrer les Déclenchements",
            close: "Fermer",
            attach: "Joindre un Fichier"
          }
        },
        confirmationModal: {
          deleteTitle: "Supprimer",
          deleteMessage: "Cette action ne peut pas être annulée."
        },
        toasts: {
          success: "Opération réalisée avec succès",
          start: "Campagne démarrée",
          cancel: "Campagne annulée",
          restart: "Campagne redémarrée",
          deleted: "Enregistrement supprimé"
        }
      },
      campaignReport: {
        title: "Rapport de",
        inactive: "Inactive",
        scheduled: "Programmée",
        process: "En Cours",
        cancelled: "Annulée",
        finished: "Terminée",
        campaign: "Campagne",
        validContacts: "Contacts Valides",
        confirmationsRequested: "Confirmations Demandées",
        confirmations: "Confirmations",
        deliver: "Délivrés",
        connection: "Connexion",
        contactLists: "Liste de Contacts",
        schedule: "Programmation",
        conclusion: "Conclusion",
        noPermission: "Cette entreprise n'a pas l'autorisation d'accéder à cette page. Redirection en cours.",
        statusLine: "Statut : {{status}} {{current}} sur {{total}}"
      },
      announcements: {
        title: "Informatifs",
        searchPlaceholder: "Recherche",
        active: "Actif",
        inactive: "Inactif",
        buttons: {
          add: "Nouvel Informatif",
          contactLists: "Listes d'Informatifs"
        },
        table: {
          priority: "Priorité",
          title: "Titre",
          text: "Texte",
          mediaName: "Fichier",
          status: "État",
          actions: "Actions"
        },
        dialog: {
          edit: "Modification d'Informatif",
          add: "Nouvel Informatif",
          update: "Modifier l'Informatif",
          readonly: "Visualisation Uniquement",
          form: {
            priority: "Priorité",
            title: "Titre",
            text: "Texte",
            mediaPath: "Fichier",
            status: "État",
            high: "Haute",
            medium: "Moyenne",
            low: "Basse",
            active: "Actif",
            inactive: "Inactif"
          },
          buttons: {
            add: "Ajouter",
            edit: "Mettre à jour",
            okadd: "Ok",
            cancel: "Annuler",
            close: "Fermer",
            attach: "Joindre un Fichier"
          }
        },
        confirmationModal: {
          deleteTitle: "Supprimer",
          deleteMessage: "Cette action ne peut pas être annulée."
        },
        toasts: {
          success: "Opération réalisée avec succès",
          deleted: "Enregistrement supprimé"
        }
      },
      campaignsConfig: {
        title: "Paramètres de Campagnes"
      },
      queues: {
        title: "Zones & Chatbot",
        table: {
          name: "Nom",
          color: "Couleur",
          greeting: "Message de bienvenue",
          orderQueue: "Ordre de la zone (bot)",
          actions: "Actions",
          ID: "ID"
        },
        buttons: {
          add: "Ajouter une zone"
        },
        toasts: {
          success: "Zone enregistrée avec succès",
          deleted: "Zone supprimée avec succès"
        },
        confirmationModal: {
          deleteTitle: "Supprimer",
          deleteMessage: "Êtes-vous sûr ? Cette action ne peut pas être annulée ! Les services de cette zone continueront d'exister, mais n'auront plus de zone attribuée."
        }
      },
      queue: {
        queueData: "Données"
      },
      queueSelect: {
        inputLabel: "Zones",
        inputLabelRO: "Zones en lecture seule",
        withoutQueue: "Sans zone",
        undefined: "Zone non trouvée",
      },
      reports: {
        title: "Rapports de Services",
        table: {
          id: "Ticket",
          user: "Utilisateur",
          dateOpen: "Date d'Ouverture",
          dateClose: "Date de Fermeture",
          NPS: "NPS",
          status: "État",
          whatsapp: "Connexion",
          queue: "Zone",
          actions: "Actions",
          lastMessage: "Dern. Message",
          contact: "Client",
          supportTime: "Temps de Service"
        },
        buttons: {
          filter: "Appliquer le Filtre",
          onlyRated: "Uniquement Évalués"
        },
        searchPlaceholder: "Rechercher...",
        tooltips: {
          openTicket: "Accéder au ticket"
        },
        export: {
          timeOpen: "Heure d'ouverture",
          timeClose: "Heure de fermeture",
          sheetName: "RapportsDeServices",
          fileName: "rapports-de-services.xlsx"
        }
      },
      queueIntegration: {
        title: "Intégrations",
        table: {
          id: "ID",
          type: "Type",
          name: "Nom",
          projectName: "Nom du Projet",
          language: "Langue",
          lastUpdate: "Dernière mise à jour",
          actions: "Actions"
        },
        buttons: {
          add: "Ajouter un Projet"
        },
        searchPlaceholder: "Rechercher...",
        confirmationModal: {
          deleteTitle: "Supprimer",
          deleteMessage: "Êtes-vous sûr ? Cette action ne peut pas être annulée ! et sera supprimée des files d'attente et connexions liées"
        }
      },
      users: {
        title: "Utilisateurs",
        table: {
          status: "État",
          name: "Nom",
          email: "E-mail",
          profile: "Profil",
          startWork: "Début de travail",
          endWork: "Fin de travail",
          actions: "Actions",
          ID: "ID"
        },
        buttons: {
          add: "Ajouter un utilisateur"
        },
        toasts: {
          deleted: "Utilisateur supprimé avec succès."
        },
        confirmationModal: {
          deleteTitle: "Supprimer",
          deleteMessage: "Toutes les données de l'utilisateur seront perdues. Les services ouverts de cet utilisateur seront déplacés vers la file d'attente."
        }
      },
      compaies: {
        title: "Entreprises",
        table: {
          ID: "ID",
          status: "Actif",
          name: "Nom",
          email: "E-mail",
          password: "Mot de passe",
          phone: "Téléphone",
          plan: "Plan",
          active: "Actif",
          numberAttendants: "Agents",
          numberConections: "Connexions",
          value: "Valeur",
          namePlan: "Nom du Plan",
          numberQueues: "Files d'attente",
          useCampaigns: "Campagnes",
          useExternalApi: "API REST",
          useFacebook: "Facebook",
          useInstagram: "Instagram",
          useWhatsapp: "WhatsApp",
          useInternalChat: "Chat Interne",
          useSchedules: "Envois massifs",
          createdAt: "Créé Le",
          dueDate: "Échéance",
          lastLogin: "Dern. Connexion",
          actions: "Actions",
          money: "€",
          yes: "Oui",
          no: "Non",
          document: "CNPJ/CPF",
          recurrence: "Récurrence",
          monthly: "Mensuel",
          bimonthly: "Bimestriel",
          quarterly: "Trimestriel",
          semester: "Semestriel",
          yearly: "Annuel",
          clear: "Effacer",
          delete: "Supprimer",
          user: "Utilisateur",
          save: "Enregistrer"
        },
        buttons: {
          add: "Ajouter une entreprise"
        },
        toasts: {
          deleted: "Entreprise supprimée avec succès."
        },
        confirmationModal: {
          deleteTitle: "Supprimer",
          deleteMessage: "Toutes les données de l'entreprise seront perdues. Les tickets ouverts de cet utilisateur seront déplacés vers la file d'attente."
        }
      },
      plans: {
        form: {
          name: "Nom",
          users: "Utilisateurs",
          connections: "Connexions",
          campaigns: "Campagnes",
          schedules: "Envois massifs",
          aiTokensIncluded: "Tokens IA inclus",
          enabled: "Activées",
          disabled: "Désactivées",
          clear: "Annuler",
          delete: "Supprimer",
          save: "Enregistrer",
          yes: "Oui",
          no: "Non",
          money: "€",
          public: "Public"
        }
      },
      helps: {
        title: "Centre d'Aide",
        settings: {
          codeVideo: "Code de la Vidéo",
          description: "Description",
          clear: "Effacer",
          delete: "Supprimer",
          save: "Enregistrer"
        }
      },
      schedules: {
        title: "Envois massifs",
        confirmationModal: {
          deleteTitle: "Êtes-vous sûr de vouloir supprimer cet envoi massif ?",
          deleteMessage: "Cette action ne peut pas être annulée."
        },
        table: {
          contact: "Contact",
          body: "Message",
          sendAt: "Date d'envoi",
          sentAt: "Date d'Envoi",
          status: "État",
          actions: "Actions"
        },
        buttons: {
          add: "Nouvel envoi massif"
        },
        toasts: {
          deleted: "Envoi massif supprimé avec succès."
        }
      },
      tags: {
        title: "Étiquettes",
        confirmationModal: {
          deleteTitle: "Êtes-vous sûr de vouloir supprimer cette Étiquette ?",
          deleteMessage: "Cette action ne peut pas être annulée."
        },
        table: {
          id: "ID",
          name: "Nom",
          kanban: "Kanban",
          color: "Couleur",
          tickets: "Enregistrements Étiquettes",
          contacts: "Contacts",
          actions: "Actions"
        },
        buttons: {
          add: "Nouvelle Étiquette"
        },
        toasts: {
          deleted: "Étiquette supprimée avec succès."
        }
      },
      tagsKanban: {
        title: "Couloirs",
        laneDefault: "En ouvert",
        confirmationModal: {
          deleteTitle: "Êtes-vous sûr de vouloir supprimer ce Couloir ?",
          deleteMessage: "Cette action ne peut pas être annulée."
        },
        table: {
          name: "Nom",
          color: "Couleur",
          tickets: "Tickets",
          actions: "Actions"
        },
        buttons: {
          add: "Nouveau Couloir"
        },
        toasts: {
          deleted: "Couloir supprimé avec succès."
        }
      },
      files: {
        title: "Liste de fichiers",
        table: {
          name: "Nom",
          contacts: "Contacts",
          actions: "Action"
        },
        toasts: {
          deleted: "Liste supprimée avec succès !",
          deletedAll: "Toutes les listes ont été supprimées avec succès !"
        },
        buttons: {
          add: "Ajouter",
          deleteAll: "Supprimer Tous"
        },
        confirmationModal: {
          deleteTitle: "Supprimer",
          deleteAllTitle: "Supprimer Tous",
          deleteMessage: "Êtes-vous sûr de vouloir supprimer cette liste ?",
          deleteAllMessage: "Êtes-vous sûr de vouloir supprimer toutes les listes ?"
        }
      },
      settings: {
        success: "Paramètres enregistrés avec succès.",
        title: "Paramètres",
        tabs: {
          options: "Options",
          plans: "Plans",
          helps: "Aide"
        },
        settings: {
          userCreation: {
            name: "Création d'utilisateur",
            options: {
              enabled: "Activé",
              disabled: "Désactivé"
            }
          },
          tabs: {
            options: "Options",
            schedules: "Horaires",
            plans: "Plans",
            help: "Aide"
          },
          options: {
            disabled: "Désactivé",
            enabled: "Activé",
            updating: "Mise à jour...",
            creationCompanyUser: "Création Entreprise/Utilisateur",
            evaluations: "Évaluations",
            officeScheduling: "Programmation de Service",
            queueManagement: "Gestion par File d'attente",
            companyManagement: "Gestion par Entreprise",
            connectionManagement: "Gestion par Connexion",
            sendGreetingAccepted: "Envoyer un message de bienvenue lors de l'acceptation du ticket",
            sendMsgTransfTicket: "Envoyer un message de transfert de secteur/agent",
            checkMsgIsGroup: "Ignorer les Messages de Groupes",
            chatBotType: "Type de Bot",
            userRandom: "Choisir un agent aléatoire",
            buttons: "Boutons",
            acceptCallWhatsapp: "Informer qu'il n'accepte pas les appels sur WhatsApp ?",
            sendSignMessage: "Permettre à l'agent de choisir d'ENVOYER la Signature",
            sendGreetingMessageOneQueues: "Envoyer un message de bienvenue quand il n'y a qu'une seule file d'attente",
            sendQueuePosition: "Envoyer un message avec la position dans la file d'attente",
            sendFarewellWaitingTicket: "Envoyer un message d'adieu en attente",
            acceptAudioMessageContact: "Accepter de recevoir de l'audio de tous les contacts ?",
            enableLGPD: "Activer le traitement RGPD",
            requiredTag: "Étiquette obligatoire pour fermer le ticket",
            closeTicketOnTransfer: "Fermer le ticket lors du transfert vers une autre file d'attente",
            DirectTicketsToWallets: "Déplacer automatiquement le client vers le portefeuille",
            showNotificationPending: "Afficher la notification pour les tickets en attente"
          },
          customMessages: {
            sendQueuePositionMessage: "Message de position dans la file d'attente",
            AcceptCallWhatsappMessage: "Message pour informer qu'il n'accepte pas les appels",
            greetingAcceptedMessage: "Message de Bienvenue lors de l'acceptation du ticket",
            transferMessage: `Message de transfert - \${queue.name} = file d'attente de destination`
          },
          LGPD: {
            title: "RGPD",
            welcome: "Message de bienvenue (RGPD)",
            linkLGPD: "Lien de la politique de confidentialité",
            obfuscateMessageDelete: "Masquer le message supprimé",
            alwaysConsent: "Toujours demander le consentement",
            obfuscatePhoneUser: "Masquer le numéro de téléphone pour les utilisateurs",
            enabled: "Activé",
            disabled: "Désactivé"
          }
        }
      },
      messagesList: {
        header: {
          assignedTo: "Attribué à :",
          dialogRatingTitle: "Voulez-vous laisser une évaluation de service pour le client ?",
          dialogClosingTitle: "Finalisation du service avec le client !",
          dialogRatingCancel: "Résoudre AVEC Message d'Adieu",
          dialogRatingSuccess: "Résoudre et Envoyer l'Évaluation",
          dialogRatingWithoutFarewellMsg: "Résoudre SANS Message d'Adieu",
          ratingTitle: "Choisissez un menu d'évaluation",
          notMessage: "Aucun message sélectionné",
          amount: "Valeur de prospection",
          buttons: {
            return: "Retourner",
            resolve: "Résoudre",
            reopen: "Rouvrir",
            accept: "Accepter",
            rating: "Envoyer l'Évaluation",
            enableIntegration: "Activer l'intégration",
            disableIntegration: "Désactiver l'intégration",
            logTicket: "Logs du Ticket",
            requiredTag: "Vous devez attribuer une étiquette avant de fermer le ticket."
          }
        },
        forwarded: "Transféré",
        deletedText: "🚫 Message supprimé",
        deletedByContactText: "🚫 Ce message a été supprimé par le contact",
        deletedMessage: "🚫 _Message supprimé_",
        reacted: "Vous avez réagi... {{reaction}}",
        editedAt: "Modifié {{time}}",
        empty: {
          startConversation: "Dites bonjour à votre nouveau contact !"
        },
        dragDrop: {
          dropHere: "Déposez le fichier ici"
        },
        facebookPolicy24h: "Vous avez 24 h pour répondre après avoir reçu un message, conformément aux politiques de Facebook."
      },
      messagesInput: {
        placeholderPrivateMessage: "Écrivez un message ou appuyez sur / pour les réponses rapides",
        placeholderOpen: "Écrivez un message ou appuyez sur / pour les réponses rapides",
        placeholderClosed: "Rouvrez ou acceptez ce ticket pour envoyer un message.",
        failedToSendFiles: "Impossible d'envoyer {{count}} fichier(s) : {{preview}}{{suffix}}",
        signMessage: "Signer",
        privateMessage: "Message Privé"
      },
      contactDrawer: {
        header: "Données du contact",
        buttons: {
          edit: "Modifier le contact",
          block: "Bloquer",
          unblock: "Débloquer"
        },
        extraInfo: "Autres informations"
      },
      messageVariablesPicker: {
        label: "Variables disponibles",
        vars: {
          contactFirstName: "Prénom",
          contactName: "Nom",
          user: "Agent",
          greeting: "Salutation",
          protocolNumber: "Protocole",
          date: "Date",
          hour: "Heure",
          ticket_id: "N° d'Appel",
          queue: "Secteur",
          connection: "Connexion"
        }
      },
      ticketOptionsMenu: {
        schedule: "Programmation",
        delete: "Supprimer",
        transfer: "Transférer",
        registerAppointment: "Observations du Contact",
        resolveWithNoFarewell: "Finaliser sans adieu",
        acceptAudioMessage: "Accepter les audios du contact ?",
        appointmentsModal: {
          title: "Observations du Ticket",
          textarea: "Observation",
          placeholder: "Insérez ici l'information que vous souhaitez enregistrer"
        },
        confirmationModal: {
          title: "Supprimer le ticket du contact",
          titleFrom: "du contact ",
          message: "Attention ! Tous les messages liés au ticket seront perdus."
        },
        buttons: {
          delete: "Supprimer",
          cancel: "Annuler"
        }
      },
      confirmationModal: {
        buttons: {
          confirm: "Ok",
          cancel: "Annuler"
        }
      },
      messageInput: {
        tooltip: {
          signature: "Activer/Désactiver la Signature",
          privateMessage: "Activer/Désactiver le Message Privé",
          meet: "Envoyer un lien pour la vidéoconférence"
        },
        type: {
          imageVideo: "Photos et vidéos",
          cam: "Caméra",
          contact: "Contact",
          meet: "Appel vidéo"
        }
      },
      messageOptionsMenu: {
        delete: "Supprimer",
        reply: "Répondre",
        edit: "Modifier",
        forward: "Transférer",
        toForward: "Transférer",
        talkTo: "Parler Avec",
        react: "Réagir",
        confirmationModal: {
          title: "Supprimer le message ?",
          message: "Cette action ne peut pas être annulée."
        }
      },
      invoices: {
        table: {
          invoices: "Factures",
          details: "Détails",
          users: "Utilisateurs",
          connections: "Connexions",
          queue: "Files d'attente",
          value: "Valeur",
          expirationDate: "Date d'Échéance",
          action: "Action"
        }
      },
      landing: {
        badge: "Plateforme commerciale 3D",
        title: "Vendez, automatisez et evoluez sur une seule plateforme",
        subtitle: "Centralisez WhatsApp, appels et suivi client avec controle en temps reel.",
        nav: {
          benefits: "Avantages",
          market: "Marche",
          pricing: "Tarifs",
          contact: "Contact",
        },
        quickPills: {
          speed: "Reponses en secondes",
          control: "Controle operationnel quotidien",
          conversion: "Plus de ventes conclues",
        },
        servicesTitle: "Services de base",
        services: {
          omnichannelTitle: "Support omnicanal",
          omnichannelDescription: "Unifiez chats et appels dans une seule boite.",
          automationTitle: "Automatisation intelligente",
          automationDescription: "Regles et flux pour repondre sans friction.",
          analyticsTitle: "Analyse commerciale",
          analyticsDescription: "Suivez performance et conversion en temps reel.",
          supportTitle: "Controle operationnel",
          supportDescription: "Assignez des taches et suivez chaque opportunite.",
        },
        benefitsTitle: "Avantages cles",
        benefitsSubtitle: "Pilotez tout votre flux commercial avec moins d'etapes et des donnees claires.",
        benefits: {
          centralizedTitle: "Operation centralisee",
          centralizedDescription: "Messages, appels et taches dans la meme vue.",
          responseTitle: "Reponse rapide",
          responseDescription: "Modeles et declencheurs pour repondre immediatement.",
          followupTitle: "Suivi constant",
          followupDescription: "Rappels et statuts pour ne perdre aucune opportunite.",
          visibilityTitle: "Vision en temps reel",
          visibilityDescription: "Tableaux de bord pour activite, tunnel et conversion.",
          teamworkTitle: "Travail en equipe",
          teamworkDescription: "Repartissez les conversations et equilibrez la charge.",
          governanceTitle: "Controle et securite",
          governanceDescription: "Permissions par role et tracabilite complete.",
        },
        market: {
          title: "Zone marketplace",
          subtitle: "Activez des modules selon votre etape et payez seulement le necessaire.",
          items: {
            automationTitle: "Flux et processus",
            automationDescription: "Automatisez ventes, support et post-vente.",
            aiTitle: "IA commerciale",
            aiDescription: "Assistants, prompts et reponses suggerees.",
            integrationsTitle: "Integrations",
            integrationsDescription: "Connectez API, canaux et outils externes.",
            billingTitle: "Facturation et plans",
            billingDescription: "Gerez abonnements, renouvellements et croissance.",
          },
          ctaHint: "Connectez-vous pour activer des modules depuis votre panel Marche.",
          ctaButton: "Se connecter et activer",
        },
        actions: {
          login: "Entrer dans l'application",
          whatsapp: "Contacter via WhatsApp",
          call: "Appeler maintenant",
        },
        contactLabel: "Contact Klorum : {{number}}",
        redirectHint: "Tous les acces de la plateforme redirigent vers le login securise.",
        footer: {
          rights: "Klorum {{year}}. Tous droits reserves.",
          note: "Acces commercial via login securise.",
        },
      },
      marketplace: {
        title: "Marketplace",
        hero: {
          title: "Marketplace",
          subtitle: "Activez des modules et add-ons pour enrichir votre compte."
        },
        stats: {
          active: "Actifs",
          available: "Disponibles",
          showing: "Affichage"
        },
        search: {
          label: "Rechercher",
          placeholder: "Ex: Catalogues, IA, Campagnes..."
        },
        filters: {
          all: "Tous",
          activeOnly: "Actifs seulement",
          sort: {
            recommended: "Recommandes",
            nameAsc: "Nom (A-Z)",
            priceAsc: "Prix (bas)",
            priceDesc: "Prix (haut)"
          }
        },
        permissions: {
          manageOnly: "Seuls admin/supervisor/superadmin peuvent activer des add-ons."
        },
        card: {
          key: "Cle",
          active: "ACTIF",
          inactive: "INACTIF",
          noDescription: "Sans description",
          category: "Categorie",
          includedInPlan: "Inclus dans votre plan",
          customized: "Personnalise",
          price: "Prix",
          free: "Gratuit"
        },
        actions: {
          refresh: "Actualiser",
          activate: "Activer",
          deactivate: "Desactiver",
          restore: "Restaurer"
        },
        empty: {
          title: "Aucun add-on disponible",
          subtitle: "Quand vous changez de plan ou un admin ajoute des add-ons, ils apparaitront ici."
        }
      },
      backendErrors: {
        ERR_NO_OTHER_WHATSAPP: "Il doit y avoir au moins un WhatsApp par défaut.",
        ERR_NO_DEF_WAPP_FOUND: "Aucun WhatsApp par défaut trouvé. Vérifiez la page des connexions.",
        ERR_WAPP_NOT_INITIALIZED: "Cette session WhatsApp n'a pas été initialisée. Vérifiez la page des connexions.",
        ERR_WAPP_CHECK_CONTACT: "Il n'a pas été possible de vérifier le contact WhatsApp. Vérifiez la page des connexions",
        ERR_WAPP_INVALID_CONTACT: "Ce n'est pas un numéro WhatsApp valide.",
        ERR_WAPP_DOWNLOAD_MEDIA: "Il n'a pas été possible de télécharger les médias de WhatsApp. Vérifiez la page des connexions.",
        ERR_INVALID_CREDENTIALS: "Erreur d'authentification. Veuillez réessayer.",
        ERR_SENDING_WAPP_MSG: "Erreur lors de l'envoi du message WhatsApp. Vérifiez la page des connexions.",
        ERR_DELETE_WAPP_MSG: "Il n'a pas été possible de supprimer le message WhatsApp.",
        ERR_OTHER_OPEN_TICKET: "Il existe déjà un ticket ouvert pour ce contact.",
        ERR_SESSION_EXPIRED: "Session expirée. Veuillez vous connecter.",
        ERR_USER_CREATION_DISABLED: "La création d'utilisateur a été désactivée par l'administrateur.",
        ERR_NO_PERMISSION: "Vous n'avez pas la permission d'accéder à cette ressource.",
        ERR_DUPLICATED_CONTACT: "Il existe déjà un contact avec ce numéro.",
        ERR_NO_SETTING_FOUND: "Aucun paramètre trouvé avec cet ID.",
        ERR_NO_CONTACT_FOUND: "Aucun contact trouvé avec cet ID.",
        ERR_NO_TICKET_FOUND: "Aucun ticket trouvé avec cet ID.",
        ERR_NO_USER_FOUND: "Aucun utilisateur trouvé avec cet ID.",
        ERR_NO_WAPP_FOUND: "Aucun WhatsApp trouvé avec cet ID.",
        ERR_CREATING_MESSAGE: "Erreur lors de la création du message dans la base de données.",
        ERR_CREATING_TICKET: "Erreur lors de la création du ticket dans la base de données.",
        ERR_FETCH_WAPP_MSG: "Erreur lors de la recherche du message dans WhatsApp, il est peut-être trop ancien.",
        ERR_QUEUE_COLOR_ALREADY_EXISTS: "Cette couleur est déjà utilisée, choisissez-en une autre.",
        ERR_WAPP_GREETING_REQUIRED: "Le message de bienvenue est obligatoire lorsqu'il y a plus d'une file d'attente.",
        ERR_OUT_OF_HOURS: "En dehors des Horaires de Service !"
      }
    }
  }
};

export { messages };
